import React from 'react';
import { Link } from 'react-router-dom';
import { toggleWatchLater, resolveFileUrl } from '../lib/api';
import { formatCount } from '../mock';
import { Clock, CheckCircle2 } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

export default function VideoCard({ video, onChanged }) {
  const ch = video.channel;
  const [saved, setSaved] = useState(!!video.saved);
  const isLive = video.type === 'live';

  const onSave = async (e) => {
    e.preventDefault(); e.stopPropagation();
    try {
      const { saved: s } = await toggleWatchLater(video.id);
      setSaved(s);
      toast.success(s ? 'Saved to Watch later' : 'Removed from Watch later');
      onChanged?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Sign in to save');
    }
  };

  return (
    <div className="group">
      <Link to={`/watch/${video.id}`} className="block">
        <div className={`thumb ${isLive ? 'live' : ''} hover-lift`}>
          <img src={resolveFileUrl(video.thumb)} alt={video.title} />
          <span className="dur">{isLive ? (<span className="inline-flex items-center gap-1"><span className="live-dot" /> LIVE</span>) : video.duration}</span>
          <button
            onClick={onSave}
            className={`absolute top-2 right-2 w-8 h-8 rounded-full grid place-items-center transition-all ${saved ? 'bg-[#ff2e63] text-white' : 'bg-black/60 text-white/80 opacity-0 group-hover:opacity-100 hover:bg-black/85'}`}
            aria-label="Watch later"
          >
            <Clock className="w-4 h-4" />
          </button>
        </div>
      </Link>
      <div className="flex gap-3 mt-3">
        {ch && (
          <Link to={`/channel/${ch.id}`} className="shrink-0">
            <img src={resolveFileUrl(ch.avatar)} alt={ch.name} className="w-9 h-9 rounded-full object-cover" />
          </Link>
        )}
        <div className="min-w-0">
          <Link to={`/watch/${video.id}`}>
            <h3 className="text-[14.5px] font-semibold text-white leading-snug line-clamp-2 hover:text-[#ff6b8a] transition-colors">{video.title}</h3>
          </Link>
          {ch && (
            <Link to={`/channel/${ch.id}`} className="flex items-center gap-1 mt-1.5 text-[13px] text-white/60 hover:text-white transition-colors">
              <span>{ch.name}</span>
              {ch.verified && <CheckCircle2 className="w-3.5 h-3.5 text-white/50" />}
            </Link>
          )}
          <div className="text-[12.5px] text-white/55 mt-0.5">
            {formatCount(video.views)} views • {video.uploaded_at || video.uploadedAt || 'just now'}
          </div>
        </div>
      </div>
    </div>
  );
}
